<script setup>
// Stroke-based minimal icon set, ported from the Samui design bundle.
// Usage: <Icon name="home" :size="18" />
defineProps({
  name:   { type: String, required: true },
  size:   { type: [Number, String], default: 18 },
  stroke: { type: [Number, String], default: 1.7 },
})
</script>

<template>
  <svg
    :width="size" :height="size" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" :stroke-width="stroke"
    stroke-linecap="round" stroke-linejoin="round"
    aria-hidden="true"
  >
    <path v-if="name === 'home'" d="M3 11l9-8 9 8v10a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1V11z" />
    <g v-else-if="name === 'rental'">
      <circle cx="6" cy="17" r="3"/><circle cx="18" cy="17" r="3"/>
      <path d="M6 17l3-8h4l3 8M9 9h3M13 9l-2-5h-2"/>
    </g>
    <g v-else-if="name === 'users'">
      <circle cx="9" cy="8" r="3.5"/>
      <path d="M3 20c.7-3.2 3.2-5 6-5s5.3 1.8 6 5"/>
      <circle cx="17" cy="7" r="2.5"/>
      <path d="M16 14c2.5 0 4.3 1.3 5 3.5"/>
    </g>
    <g v-else-if="name === 'fleet'">
      <rect x="3" y="8" width="12" height="8" rx="2"/>
      <path d="M15 10h3l3 3v3h-6"/>
      <circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/>
    </g>
    <g v-else-if="name === 'map'">
      <path d="M9 3L3 5v16l6-2 6 2 6-2V3l-6 2-6-2z"/>
      <path d="M9 3v16M15 5v16"/>
    </g>
    <path v-else-if="name === 'sign'" d="M3 18h18M5 14l6-6 3 3-6 6H5v-3zM13 8l3-3 3 3-3 3"/>
    <g v-else-if="name === 'settings'">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19 12a7 7 0 0 0-.1-1.2l2-1.5-2-3.4-2.3.9a7 7 0 0 0-2.1-1.2L14 3h-4l-.5 2.6a7 7 0 0 0-2.1 1.2l-2.3-.9-2 3.4 2 1.5A7 7 0 0 0 5 12c0 .4 0 .8.1 1.2l-2 1.5 2 3.4 2.3-.9a7 7 0 0 0 2.1 1.2L10 21h4l.5-2.6a7 7 0 0 0 2.1-1.2l2.3.9 2-3.4-2-1.5c.1-.4.1-.8.1-1.2z"/>
    </g>
    <g v-else-if="name === 'search'">
      <circle cx="11" cy="11" r="7"/>
      <path d="M20 20l-3.5-3.5"/>
    </g>
    <path v-else-if="name === 'plus'" d="M12 5v14M5 12h14"/>
    <path v-else-if="name === 'chev-r'" d="M9 6l6 6-6 6"/>
    <path v-else-if="name === 'chev-l'" d="M15 6l-6 6 6 6"/>
    <path v-else-if="name === 'chev-d'" d="M6 9l6 6 6-6"/>
    <path v-else-if="name === 'bell'" d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9zM9 21a3 3 0 0 0 6 0"/>
    <g v-else-if="name === 'bell-off'">
      <path d="M6 8a6 6 0 0 1 9.6-4.8M18 8c0 3.4.7 5.7 1.5 7M3 17h15M9 21a3 3 0 0 0 6 0"/>
      <path d="M3 3l18 18"/>
    </g>
    <path v-else-if="name === 'x'" d="M6 6l12 12M18 6l-12 12"/>
    <path v-else-if="name === 'check'" d="M4 12l5 5 11-11"/>
    <path v-else-if="name === 'filter'" d="M3 5h18M6 12h12M10 19h4"/>
    <path v-else-if="name === 'menu'" d="M3 6h18M3 12h18M3 18h18"/>
    <path v-else-if="name === 'phone'" d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/>
    <g v-else-if="name === 'mail'">
      <rect x="3" y="5" width="18" height="14" rx="2"/>
      <path d="M3 7l9 6 9-6"/>
    </g>
    <path v-else-if="name === 'chat'" d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-4 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" />
    <path v-else-if="name === 'dot'" d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" fill="currentColor" stroke="none"/>
    <g v-else-if="name === 'calendar'">
      <rect x="3" y="5" width="18" height="16" rx="2"/>
      <path d="M3 10h18M8 3v4M16 3v4"/>
    </g>
    <path v-else-if="name === 'refresh'" d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5"/>
    <path v-else-if="name === 'download'" d="M12 3v13M6 11l6 6 6-6M4 21h16"/>
    <g v-else-if="name === 'print'">
      <path d="M7 9V3h10v6M7 18H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
      <rect x="7" y="14" width="10" height="7" rx="1"/>
    </g>
    <g v-else-if="name === 'share'">
      <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
      <path d="M8.6 10.5l6.8-4M8.6 13.5l6.8 4"/>
    </g>
    <g v-else-if="name === 'sun'">
      <circle cx="12" cy="12" r="4"/>
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1"/>
    </g>
    <path v-else-if="name === 'moon'" d="M21 13A9 9 0 1 1 11 3a7 7 0 0 0 10 10z"/>
    <g v-else-if="name === 'tweaks'">
      <path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M18 18h2"/>
      <circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="16" cy="18" r="2"/>
    </g>
    <g v-else-if="name === 'pin'">
      <path d="M12 22s7-7.5 7-13a7 7 0 1 0-14 0c0 5.5 7 13 7 13z"/>
      <circle cx="12" cy="9" r="2.5"/>
    </g>
    <path v-else-if="name === 'bolt'" d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/>
    <g v-else-if="name === 'truck'">
      <path d="M3 7h11v9H3z"/>
      <path d="M14 10h4l3 3v3h-7z"/>
      <circle cx="7" cy="18" r="1.7"/>
      <circle cx="17" cy="18" r="1.7"/>
    </g>
    <path v-else-if="name === 'paperclip'" d="M21 11.5l-9.5 9.5a5.5 5.5 0 0 1-7.78-7.78L13.5 3.5a4 4 0 0 1 5.66 5.66L9.5 18.83a2.5 2.5 0 0 1-3.54-3.54L15 6.5"/>
    <path v-else-if="name === 'logout'" d="M14 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2M9 12h12M18 9l3 3-3 3"/>
    <g v-else-if="name === 'sidebar-full'">
      <rect x="3" y="4" width="18" height="16" rx="2"/>
      <path d="M9 4v16"/>
      <path d="M5.5 9h1.5M5.5 12h1.5M5.5 15h1.5"/>
    </g>
    <g v-else-if="name === 'sidebar-rail'">
      <rect x="3" y="4" width="18" height="16" rx="2"/>
      <path d="M8 4v16"/>
    </g>
    <rect v-else-if="name === 'sidebar-hidden'" x="3" y="4" width="18" height="16" rx="2"/>
    <g v-else-if="name === 'layout-table'">
      <rect x="3" y="4" width="18" height="16" rx="2"/>
      <path d="M3 9h18M3 14h18M3 19h18"/>
    </g>
    <g v-else-if="name === 'layout-cards'">
      <rect x="3" y="3" width="8" height="8" rx="1.5"/><rect x="13" y="3" width="8" height="8" rx="1.5"/>
      <rect x="3" y="13" width="8" height="8" rx="1.5"/><rect x="13" y="13" width="8" height="8" rx="1.5"/>
    </g>
    <path v-else-if="name === 'layout-list'" d="M4 6h16M4 12h16M4 18h16"/>
    <path v-else-if="name === 'alert'" d="M12 9v4m0 4h.01M10.27 4.93L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.73 4.93a2 2 0 0 0-3.46 0z"/>
    <g v-else-if="name === 'clock'">
      <circle cx="12" cy="12" r="9"/>
      <path d="M12 7v5l3 2"/>
    </g>
    <path v-else-if="name === 'arrow-up'" d="M12 19V5M5 12l7-7 7 7"/>
    <path v-else-if="name === 'arrow-down'" d="M12 5v14M5 12l7 7 7-7"/>
    <path v-else-if="name === 'sort'" d="M8 3v18M4 7l4-4 4 4M16 21V3M12 17l4 4 4-4"/>
    <path v-else-if="name === 'loader'" d="M12 3v3M12 18v3M5.64 5.64l2.12 2.12M16.24 16.24l2.12 2.12M3 12h3M18 12h3M5.64 18.36l2.12-2.12M16.24 7.76l2.12-2.12"/>
    <path v-else-if="name === 'guide'" d="M12 6c-1.5-1-4-1.5-6-1.2v12c2-.3 4.5.2 6 1.2 1.5-1 4-1.5 6-1.2v-12c-2-.3-4.5.2-6 1.2zM12 6v12" />
    <g v-else-if="name === 'compass'">
      <circle cx="12" cy="12" r="9"/>
      <path d="M15.5 8.5l-2.2 4.8-4.8 2.2 2.2-4.8 4.8-2.2z"/>
    </g>
    <circle v-else cx="12" cy="12" r="9"/>
  </svg>
</template>
